/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
type ListComponent_suggestions$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type ChangerComponent_orgs$ref: FragmentReference;
declare export opaque type ChangerComponent_orgs$fragmentType: ChangerComponent_orgs$ref;
export type ChangerComponent_orgs = $ReadOnlyArray<{|
  +id: string,
  +name: string,
  +$fragmentRefs: ListComponent_suggestions$ref,
  +$refType: ChangerComponent_orgs$ref,
|}>;
export type ChangerComponent_orgs$data = ChangerComponent_orgs;
export type ChangerComponent_orgs$key = {
  +$data?: ChangerComponent_orgs$data,
  +$fragmentRefs: ChangerComponent_orgs$ref,
};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "ChangerComponent_orgs",
  "type": "PicklistInterface",
  "metadata": {
    "plural": true
  },
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "id",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "name",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "FragmentSpread",
      "name": "ListComponent_suggestions",
      "args": null
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = 'c293f827ce91578d9f9e56ff8021ab1c';
module.exports = node;
